<template>
  <div>
    <Carousel
      :nav="nav"
      :margin="margin"
      :items="items"
      :dots="dots"
      :slideBy="items"
      :rewind="false"
      class="hidden md:block"
    >
      <slot></slot>
    </Carousel>
    <Carousel
      :nav="nav"
      :margin="margin"
      :items="2"
      :dots="dotsMobile"
      :rewind="false"
      :slideBy="2"
      class="md:hidden"
    >
      <slot></slot>
    </Carousel>
  </div>
</template>
<script>
import Carousel from 'vue-owl-carousel2'

export default {
  name: 'ItemsCarousel',
  components: { Carousel },
  props: {
    items: {
      type: Number,
      default: 6
    },
    margin: {
      type: Number,
      default: 15
    },
    nav: {
      type: Boolean,
      default: false
    },
    dots: {
      type: Boolean,
      default: true
    },
    dotsMobile: {
      type: Boolean,
      default: true
    }
  }
}
</script>
